const pagePathSegments = {
	APIKeys: 'api-keys',
	About: 'about',
	AccessRequests: 'access-requests',
	AccessRules: 'access-rules',
	Assigned: 'assigned',
	Auth: 'auth',
	Batches: 'batches',
	Callback: 'signin-callback-oidc',
	Create: 'create',
	Data: 'data',
	DeviceGroups: 'device-groups',
	Devices: 'devices',
	DevicesAssignments: 'device-assignments',
	DockingLocations: 'docking-locations',
	Events: 'events',
	Finance: 'finance',
	General: 'general',
	Help: 'help',
	Home: '/',
	Inventory: 'inventory',
	KeyGroups: 'key-groups',
	Keys: 'keys',
	Webhooks: 'webhooks',
	Login: 'login',
	Logout: 'logout',
	Logs: 'logs',
	Manufacturing: 'manufacturing',
	Metrics: 'metrics',
	Notifications: 'notifications',
	OfflineAccess: 'offline-access',
	Operations: 'operations',
	OrganisationHistory: 'organisation-history',
	Organisations: 'organisations',
	Processing: 'processing',
	Profile: 'profile',
	ReleaseNotes: 'wiki/ab09011fa121',
	Register: 'register',
	Rental: 'rental',
	ResourceGroups: 'resource-groups',
	Sandbox: 'sandbox',
	ScheduledActions: 'scheduled-actions',
	Silent: 'silent',
	Subscriptions: 'subscriptions',
	Telemetry: 'telemetry',
	Trips: 'trips',
	Unassigned: 'unassigned',
	UsageOverview: 'usage-overview',
	Users: 'users',
	Verification: 'verification',
	Wiki: 'wiki',
} as const;

export default pagePathSegments;
